





















































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import TrainOrder from "@/service/trainService";
import { DurationTime } from "@/utils/utils.ts";
import { Checkbox, CheckboxGroup, Overlay } from "vant";
@Component({
  name: "trainCahngePdt",
  components: {
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Overlay.name]: Overlay,
  },
})
export default class TrainCahngePdt extends Vue {
  //data
  productData = [];
  result: any = [];
  consumerResult: any[] = [];
  isShowRules = false;
  //computed
  get UniqueID(): string {
    return (this as any).$route.query.UniqueID;
  }
  get ServiceCode(): string {
    return (this as any).$route.query.ServiceCode;
  }
  //mounted
  mounted() {
    this.getOrderDetails();
  }
  //methods
  getOrderDetails() {
    TrainOrder.OrderDetails(this.UniqueID).then(res => {
      if (res.isSucc) {
        this.productData = res.result;
      }
    });
  }
  changeProducts(value: any) {
    this.$emit("setResult", value);
  }
  changeConsumers(value: any) {
    this.$emit("setConsumerResult", value);
  }
  formatDate(value: Date, format: string = "HH:mm") {
    if (!value) {
      return value;
    }
    return (this as any).$moment(value).format(format);
  }
  showRules(value: any) {
    this.$emit("showRules", value);
  }

  duration(value: number) {
    return DurationTime(value / 1000 / 60);
  }
}
